import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const ProjectsSearch = ({ value, onChange, onClear }) => {
  const handleChange = (e) => {
    onChange?.(e.target.value);
  };

  const handleClear = () => {
    onClear?.();
    onChange?.('');
  };

  return (
    <TextField
      size="small"
      placeholder="Search projects…"
      fullWidth
      value={value}
      onChange={handleChange}
      className="projectsSearchInput"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear} disabled={!value} aria-label="Clear search">
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ProjectsSearch;
